import { FileManagerItemCard } from "@/components/core/FileManager/components/FileManagerItemCard/FileManagerItemCard.tsx";

import styles from "./ShareCard.module.scss";

export interface ShareCardItem {
  id: string;
  name: string;
  type: "FOLDER" | "FILE";
  contentType: string | null;
  fileSize: number | null;
  createdAt: string;
  updatedAt: string;
}

interface ShareCardProps {
  item: ShareCardItem;
  subtitle: string;
  onOpen: () => void;
  /** The ⋮ button drives a context menu, so show it only where one wraps the card. */
  showMenu?: boolean;
}

export function ShareCard({ item, subtitle, onOpen, showMenu = false }: ShareCardProps) {
  return (
    <div className={styles.shareCard}>
      <FileManagerItemCard
        item={{ ...item, parentId: null, s3Key: null, tags: [], childCount: 0 }}
        subtitle={subtitle}
        showMenu={showMenu}
        wrapSubtitle
        onOpen={onOpen}
      />
    </div>
  );
}
